// extracted by mini-css-extract-plugin
export default {"MapMarker":"LocationMarker_MapMarker__f8y3F","CurrentLocation":"LocationMarker_CurrentLocation__JAQ-p"};